import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = { 
    confirmMessage: String,
    variantIndex: Number,
    attachmentType: String 
  }

  connect() {
    // Ensure all delete buttons reference this controller
    this.setupDeleteButtons()
  }

  setupDeleteButtons() {
    this.containerTarget.querySelectorAll('[data-attachment-item]').forEach(item => {
      const deleteButton = item.querySelector('[data-action*="attachment-remover#delete"]')
      if (!deleteButton) {
        const button = item.querySelector('button')
        if (button) {
          button.setAttribute('data-action', 'click->attachment-remover#delete')
        }
      }
    })
  }

  delete(event) {
    event.preventDefault()
    
    const confirmed = confirm(this.confirmMessageValue)
    if (!confirmed) return

    const item = event.currentTarget.closest('[data-attachment-item]')
    if (!item) return

    const blobId = item.dataset.blobId
    const attachmentId = item.dataset.attachmentId
    
    if (!blobId && !attachmentId) {
      console.error('No blob ID or attachment ID found')
      return
    }

    // Mark for deletion by adding hidden input to form
    this.markForDeletion(blobId || attachmentId, this.attachmentTypeValue)
    
    // Remove from UI immediately
    item.remove()
    
    // Update the media order input
    this.updateMediaOrder()
  }

  markForDeletion(blobId, type) {
    // Find or create the hidden container for marked attachments
    let destroyContainer = document.querySelector('[data-attachment-destroy-container]')
    if (!destroyContainer) {
      // Find the nearest form
      const form = this.containerTarget.closest('form')
      if (form) {
        destroyContainer = document.createElement('div')
        destroyContainer.setAttribute('data-attachment-destroy-container', '')
        destroyContainer.className = 'hidden'
        form.appendChild(destroyContainer)
      }
    }

    if (!destroyContainer) return

    // Create hidden input to mark for deletion
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = `product[variants_attributes][${this.variantIndexValue}][${type}_to_delete][]`
    input.value = blobId
    destroyContainer.appendChild(input)
  }

  updateMediaOrder() {
    // Get remaining blob IDs from visible items
    const remainingItems = this.containerTarget.querySelectorAll('[data-attachment-item]')
    const blobIds = Array.from(remainingItems)
      .map(item => item.dataset.blobId)
      .filter(id => id)

    // Update the media order input
    const orderInput = this.containerTarget.querySelector('[data-sortable-photos-target="orderInput"]')
    if (orderInput) {
      orderInput.value = JSON.stringify(blobIds)
    }
  }
}
